import { render, staticRenderFns } from "./comp_recoveryPassword.vue?vue&type=template&id=fdbcfb12&scoped=true"
import script from "./comp_recoveryPassword.vue?vue&type=script&lang=js"
export * from "./comp_recoveryPassword.vue?vue&type=script&lang=js"
import style0 from "./comp_recoveryPassword.vue?vue&type=style&index=0&id=fdbcfb12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbcfb12",
  null
  
)

export default component.exports